import React from "react";
import Markdown from "react-markdown";
import { withRouter } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { ContainerWrapper, SectionWrapper, FlexCenter, HelmetTitle } from "../../Components/Utils";
import Banner from "../Certificates/Components/Banner";
import Layout from "../../Components/Layout";
import Navbar from "../BannerItems/Components/Navigation";
import "./index.css";

import BannerBig from "../../Images/min-1600-hero.jpg";
import BannerSmall from "../../Images/max-600-hero.jpg";

import CyberMarkdown from "./Contents/CybersecurityAssessment.md";
import GERSMarkdown from "./Contents/GERSAssessment.md";


const AssessmentTypes = [
  {
    name: "Cybersecurity Self Assessment",
    md: CyberMarkdown,
  },
  {
    name: "GERS Self Assessment",
    md: GERSMarkdown,
  }
]
class Assessment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cyber: 'Loading..',
      gers: 'Loading..',
    };
    this.update = this.update.bind(this);
  }
    
  componentDidMount() {
    let [cyberM, gersM] = AssessmentTypes.map(assess => assess.md);
    this.update('cyber', cyberM);
    this.update('gers', gersM);
    window.scrollTo(0, 0);
  }
 
  update(tab, path) {
    return fetch(path, {
      method: 'get',
      headers: {},
    }).then(response => {
      return response.text()
    }).then(text => {
      this.setState({[tab]: text})
    })
  }
    
  render() {
    const name = "Assess"
    return (
      <div className="App">
        <HelmetTitle title="Assess" />
        <Layout
          head={<Navbar />}
          body={
            <React.Fragment>
              <Banner certName={name} imgPathMin={BannerBig} imgPathMax={BannerSmall} />
              <TabbedContent 
                cybermd={<Markdown escapeHtml={false} source={this.state.cyber} />}
                GERSmd={<Markdown escapeHtml={false} source={this.state.gers} />}
              />
          </React.Fragment>
          }
        />
      </div>
    );
  }
}

class TabbedContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tabIndex: 0 };
    this.setTabIndex = this.setTabIndex.bind(this);
  }
  componentDidMount() {
    this.setTabIndex();
  }

  setTabIndex() {
    return window.location.hash ? this.setState({ tabIndex: 1}) : '';
  }
  render() {
    const tablistClass = ['w-100', 'certificates-tabs', 'd-inline-flex', 'flex--center'];
    const tabListItem = ['tab-item', 'section__header--small']
    const tabcontentClass = ['certificates-panel'];
    return (
      <SectionWrapper backgroundColor="white" mt="2rem" mb="3rem">
        <ContainerWrapper>
          {/* <h3 className="text-left">Assess capability to grow</h3>                       */}
          <Tabs selectedIndex={this.state.tabIndex} onSelect={tabIndex => this.setState({ tabIndex })}> 
            <TabList className={tablistClass}>
              <Tab className={tabListItem}>GERS</Tab>
              <Tab className={tabListItem}>Cybersecurity</Tab>
            </TabList>    
            <TabPanel className={tabcontentClass}>
              {this.props.GERSmd}
            </TabPanel>
            <TabPanel className={tabcontentClass}>
              {this.props.cybermd}
              <FlexCenter><a href="/Files/Cybersecurity_SelfAssessment.pdf" alt="Download cybersecurity self assessment pdf file" target="_blank" rel="noopener noreferrer">Download file</a></FlexCenter>
            </TabPanel>
          </Tabs>
         </ContainerWrapper>
      </SectionWrapper>
    )
  }
}
TabbedContent.defaultProps = {
 cybermd: 'No content yet',
 GERSmd: 'No content yet',
}

export default withRouter(Assessment)



// WEBPACK FOOTER //
// ./src/Pages/Offers/Assessment.js